class ErrorHandle {
    constructor(error) {
        this.error = error;
    }

    get isTimeout() {
        var statusCode = this.error.response ? this.error.response.status : 773;
        if (this.error.code === 'ECONNABORTED' || statusCode == 408) {
            return true;
        }

        return false;
    }

    get format() {
        var statusCode = this.error.response ? this.error.response.status : 773;
        var error = this.error.response
            ? this.error.response.data
                ? this.error.response.data.outcome
                    ? this.error.response.data.outcome.message
                    : this.error.response.data.message
                : this.error
            : this.error;

        if (this.error.code === 'ECONNABORTED') {
            statusCode = 408
        }

        return { error, statusCode }
    }
}

module.exports = ErrorHandle;